/**
 * 담당자가 보는 PDF(원본 PDF·엑셀의 화면용 PDF)를 pdf.js로 연다. 캔버스에 직접 그려야 확대가 깜박이지 않고 선명하다.
 * 라이브러리는 처음 열 때만 받고 문서마다 자기 워커를 쓴다 — 공유하면 한 문서를 닫을 때 다른 문서도 끊긴다.
 * signal로 중단하면 문서·워커를 닫고, 받는 중에 중단되면 열지 않는다. Web Worker가 없으면 실패해 내장 뷰어로 떨어진다.
 */
export async function openPdf(url, { signal } = {}) {
    if (typeof Worker === 'undefined') throw new Error('Web Workers are not available');
    const [pdfjs, { default: workerUrl }] = await Promise.all([import('pdfjs-dist'), import('./pdfWorkerUrl')]);
    if (signal?.aborted) throw new DOMException('The PDF was closed before it opened.', 'AbortError');
    if (!pdfjs.GlobalWorkerOptions.workerSrc) pdfjs.GlobalWorkerOptions.workerSrc = workerUrl;
    const task = pdfjs.getDocument({ url, withCredentials: false });
    if (signal) signal.addEventListener('abort', () => task.destroy(), { once: true });
    return task.promise;
}

/** 페이지 하나를 화면 폭에 맞춰 캔버스에 그린다. 고해상도 화면만큼 크게 그려 글자가 흐리지 않다. 돌려주는 함수로 그리기를 멈춘다. */
export function drawPage(page, canvas, cssWidth, dpr = window.devicePixelRatio || 1) {
    const base = page.getViewport({ scale: 1 });
    const scale = cssWidth / base.width;
    const viewport = page.getViewport({ scale: scale * dpr });
    canvas.width = Math.floor(viewport.width);
    canvas.height = Math.floor(viewport.height);
    canvas.style.width = `${cssWidth}px`;
    canvas.style.height = `${Math.floor(viewport.height / dpr)}px`;
    const task = page.render({ canvasContext: canvas.getContext('2d'), viewport });
    task.promise.catch(() => {}); // 취소는 오류가 아니다
    return () => task.cancel();
}
